import {useState, useEffect, ReactElement} from 'react';
import { useNavigate } from 'react-router';
import './Stylesheets/Posts.css';
import './Stylesheets/Global.css';
import axios from 'axios';
import { upload } from '@testing-library/user-event/dist/upload';
import { i } from 'react-router/dist/development/index-react-server-client-kY8DvDF3';
import {Category} from '../Interfaces/Category';
import addPhotoLogo from '../Icons/CreatePost/addphoto.svg';

import Popup from '../InnerComponents/Popup';

export default function CreatePost(){

    // Navigation
    const navigate = useNavigate();

    // State for uploaded files
    const [uploadedFile, setUploadedFile] = useState<File>();

    // State for error message
    const [error, setError] = useState<String>("");

    // Category list for option display
    const [categories, setCategories] = useState<Category[]>();

    // For notification pop up
    const [popUp, setPopUp] = useState(false);

    // File type is img by default
    const [fileType, setFileType] = useState<string>("img");

    // Backend URL
    const backend_url = process.env.REACT_APP_BACKEND_URL;

    // Retrieve appropriate preview of uploaded file
    const renderPreview  = () => {
        switch(fileType){
            case "img": return <img src={uploadedFile ? URL.createObjectURL(uploadedFile!) : addPhotoLogo}></img>
            case "pdf": return <iframe className={"pdf-preview-frame"} src={uploadedFile ? URL.createObjectURL(uploadedFile!) : addPhotoLogo}></iframe>  
            default: return <img src={uploadedFile ? URL.createObjectURL(uploadedFile!) : addPhotoLogo}></img>
        }
        
    }

    useEffect( ()=> {
        axios.get(`${backend_url}/Blog/GetCategories`)
        .then(response => setCategories(response.data.content))
    }, [])

    useEffect(() => {
       categories?.map( (Category, Id) => { 
            console.log(Category['categoryId']);
       })
    }, [categories])

    // validate user session
    useEffect(() => {
        // GET Post to process sesssion
        axios.get(`${backend_url}/Login/ProcessSession`, {withCredentials: true})
        .then(res => {
            console.log("valid session")
        })
        .catch((error) => {
            console.log(error.response?.status);
            if ( error.response?.status === 401){
                navigate('/adminlogin');
            }
        })
    }, [])

    // Retrieve categories
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = e.target.files;

        if (!fileList){
            return;
        }

        const fileType: string = fileList[0].name.split(".").pop()!;

        setFileType(fileType);

        // File List HAS to not be null at this point
        setUploadedFile(fileList![0]);
    } 

    // Create post function
    const createPost = (e : React.FormEvent<HTMLFormElement>) => {
 
        e.preventDefault();

        const content = new FormData(e.currentTarget);

        

        if (!uploadedFile) {
            setError("Please upload a file to publish.");
            return;
        }
        
        content.append('ImageToUpload', uploadedFile!, uploadedFile!.name);

        axios.post(`${backend_url}/Blog/CreatePost`, content, {withCredentials: true})
        .then( res => {
      
                if (!(res.data.status == 200) || !(res.data.status == 500)){
                    setPopUp(true);
                }
      

        })
        .catch((error) => console.log(error.message));
    }

    return (
        <>
            <div className={"create-post-content"}>
                {popUp ? <Popup message={"Your Post has been successfully created!"} title={"Post Created"} onClose={() => setPopUp(false)} /> : null }

                <div className={"create-post-form-container"}>
                    <h1>Publish new work</h1>
                    <hr></hr>
                    
                    <form className={"create-post-form"} onSubmit={createPost}>
                        <label>Title
                            <input placeholder='Title' name={"PostTitle"}  defaultValue={"-"} required type="text"></input>
                        </label>
                        
                        <label>Description
                            <textarea placeholder='Description of work' name={"PostBody"} defaultValue={"-"} required></textarea>
                        </label>
                        
                        <label>Category
                            <select name={"CategoryId"} required>
                                {categories?.map((entry, index) => 
                                (
                                    <option value={entry.categoryId}>{entry.categoryName}</option>
                                ))}
                            </select>
                        </label>

                        <label>Work to upload
                            <input id={"ImageToUpload"} name={"imageFile"} type={"file"} onChange={handleChange}></input>
                        </label>

                        <p className={"error-message"}>{error}</p>
                        <input className={"formSubmit"} type={"submit"}></input>
                    </form>
                </div>

                <div className={ uploadedFile? "image-preview-box active" : "image-preview-box"}>
                    {renderPreview()}
                    <p>Image Preview</p>
                </div>


            </div>


        </>


    )
}